module.exports = __webpack_public_path__ + "images/74867b62a094c076e5eb73ba15ef4a61.jpg";